<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-03-12 13:08:32
 * @LastEditTime: 2025-08-18 15:56:14
 * @LastEditors: 刘小二
 * @Description  : 生产运输
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/smart/schedul/productTransport_outside.vue
-->
<template>
  <div class="main-container table">
    <el-container>
      <!-- 第一部分 -->
      <el-main style="padding:2px 20px 0px 20px; 0">
        <div style="display:flex">
          <div class="tabtop" style="width: 379px">
            <div v-for="(item, index) in tabList" :key="index" @click="choose(item.status)">
              <div :class="currenindex == item.status ? 'active' : 'text'">
                {{ item.value }}
              </div>
            </div>
          </div>
          <div style="margin-top:16px ;font-size: 16px;display:flex;align-items: center;">
            <div v-if="currenindex == 1">
              <span style="display: inline-block; margin-bottom: 0px">
                <span style="margin-right: 12px">订单状态</span>
                <el-select v-model="tableParams1.orderStatus" style="width: 100px" placeholder="请选择">
                  <el-option v-for="(item, index) in oderStatusList" :key="index" :label="item.name" :value="item.value"
                    @click.native="changeOrderStatus(item)"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">浇筑日期</span>
                <el-date-picker v-model="tableParams1.pourTime" style="width: 200px" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" @change="queryPlanList()"> </el-date-picker>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">高级查询</span>
                <el-input v-model="tableParams1.productName" style="width: 200px" placeholder="请输入客户/工程/产品/部位"
                  @keyup.enter.native="queryPlanList()" />
              </span>
              <el-button style="margin-left: 12px" icon="el-icon-search" size="medium" class="bottom_all but1"
                @click="queryPlanList()">查
                询</el-button>
            </div>
            <div v-if="currenindex == 2">
              <span style="display: inline-block; margin-bottom: 0px">
                <span style="margin-right: 12px">订单状态</span>
                <el-select v-model="tableParams4.taskStatus" style="width: 100px" placeholder="请选择">
                  <el-option v-for="(item, index) in taskStatusList" :key="index" :label="item.name" :value="item.value"
                    @click.native="queryPlanList(); setPlanStartTime()"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">发料时间</span>
                <el-date-picker v-model="tableParams4.planStartTime" :disabled="tableParams4.taskStatus == 1"
                  style="width: 200px" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"
                  @change="queryPlanList()"> </el-date-picker>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">高级查询</span>
                <el-input v-model="tableParams4.product" style="width: 200px" placeholder="请输入客户/工程/产品/部位"
                  @keyup.enter.native="queryPlanList()" />
              </span>
              <el-button style="margin-left: 12px" icon="el-icon-search" size="medium" class="bottom_all but1"
                @click="queryPlanList(), getStationTaskList()">查
                询</el-button>

              <el-button v-if="currenindex == 2" style="margin-left: 12px" size="medium" class="bottom_all but1"
                @click="ToViewTypeFun({ stationId: stationInfo.id }, 3)">物流明细</el-button>
            </div>
            <div class="searchRight">
              <span>
                <span style="margin-right: 12px; font-size: 24px">站点:{{ stationInfo.name }}</span>
              </span>
              <span style="display: flex; align-items: center">
                <el-avatar size="medium" :src="headerImage" style="margin-right: 12px"></el-avatar>
                <span style="margin-right: 12px; font-size: 24px">{{ UserInfo.userRealName }}</span>
              </span>
            </div>
          </div>
        </div>
        <div v-loading="table1Load" class="card_info" :style="style">

          <el-table-draggable :data="tableData1" column>
            <el-table ref="table1" :key="currenindex == 1 ? tableParams1.orderStatus : 9"
              :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
              style="width: 100%" :height="Number(newScreenHeight * 7 / 12).toFixed(2) - 34" :data="tableData1"
              tooltip-effect="dark" :row-class-name="rowClassName">
              <template v-for="(item, index2) in table1">
                <el-table-column v-if="item.status" :key="index2 + columKey" :label="item.label"
                  :width="item.label == '发料' ? (isMaterialIssue ? '100' : '70') : item.width" :fixed="item.fixed"
                  :show-overflow-tooltip="item.label == '优先等级' || item.label == '在外车辆设置' ? false : true"
                  :align="item.label == '工程名称' || item.label == '浇筑部位' || item.label == '浇筑方式' || item.label == '产品名称' ? '' : 'center'">
                  <template slot="header">
                    <el-link v-if="item.label == '操作' && currenindex == 2" type="danger" style="margin-left: 10px"
                      :underline="false" @click="pauseAllTask()">全部暂停</el-link>
                  </template>
                  <template slot-scope="scope">
                    <span v-if="item.label == '过磅照片' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-button size="mini" class="bottom_one" @click="lookPicture(scope.row)">查看</el-button>
                    </span>
                    <span
                      v-else-if="item.label == '优先等级' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-select v-if="currenindex == 1" v-model="scope.row.transportSort" style="width: 75px"
                        placeholder="请选择">
                        <el-option v-for="(item, index) in transportSortList" :key="index" :label="item.itemName"
                          :value="item.itemValue * 1" @click.native="changeTransportSort(item, scope.row)"></el-option>
                      </el-select>
                      <el-select v-if="currenindex == 2" v-model="scope.row.sortNum" style="width: 75px"
                        placeholder="请选择">
                        <el-option v-for="(item, index) in transportSortList" :key="index" :label="item.itemName"
                          :value="item.itemValue * 1" @click.native="changeTransportSort(item, scope.row)"></el-option>
                      </el-select>
                    </span>
                    <span v-else-if="item.label == '开工' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-link v-if="tableParams1.orderStatus == 2" type="success" :underline="false"
                        @click="workStartEnd(3, scope.row)"> 开工 </el-link>
                    </span>
                    <span
                      v-else-if="item.label == '累计车数' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-link type="primary" :underline="false" @click="ToViewTypeFun(scope.row, currenindex)"> {{
                        scope.row.cumulativeCar }}{{ scope.row.taskCarNums ? `(${scope.row.taskCarNums})` : '' }}
                      </el-link>
                    </span>
                    <span
                      v-else-if="item.label == '累计方量' || item.label == '累计发料' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <span>
                        {{
                          scope.row.cumulativeUseNum }}{{ scope.row.taskNum ? `(${scope.row.taskNum})` : '' }}
                      </span>
                    </span>
                    <span
                      v-else-if="item.label == '在外车辆设置' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-input v-if="currenindex == 1" v-model="scope.row.maxOutCarNoCount" type="number"
                        style="width: 90px" placeholder="请输入" @change="changeMaxOutCarNum(scope.row)">
                      </el-input>
                      <span v-if="currenindex == 2" :style="{ color:scope.row.maxOutCarNum != null && scope.row.outCarNos > scope.row.maxOutCarNum ? 'red' : 'black' }">
                        {{scope.row.maxOutCarNum }}
                      </span>
                    </span>
                    <span
                      v-else-if="item.label == '在外车辆' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-popover v-if="scope.row.outCarNos" :key="scope.row.planId" :offset="100" placement="top"
                        :close-delay="100" width="260" trigger="hover">
                        <div class="outCarNos">
                          <span v-for="(carItem, carIndex) in scope.row.outCarNos" :key="carIndex"
                            style="margin-left: 10px">{{ carItem }}</span>
                        </div>
                        <el-link slot="reference" type="warning" style="width: 30px" :underline="false"> {{
                          scope.row.outCarNoCount }} </el-link>
                      </el-popover>
                      <el-link v-else style="width: 30px" type="info" :underline="false">{{ scope.row.outCarNoCount
                      }}</el-link>
                    </span>
                    <span v-else-if="item.label == '发料' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-button v-if="tableParams1.orderStatus == 3 && scope.row.materialIssueType == 0" size="mini"
                        style="margin-left: 0px" class="bottom_all but1" @click="issueGoods(scope.row)">发料</el-button>
                      <el-button v-if="tableParams1.orderStatus == 3 && scope.row.materialIssueType == 1" size="mini"
                        style="margin-left: 10px" class="bottom_all but1"
                        @click="autoIssueGoods(scope.row)">自动发料</el-button>
                    </span>
                    <span v-else-if="item.label == '状态'">
                      <span v-if="scope.row.taskStatus == 0">取消</span>
                      <span v-else-if="scope.row.taskStatus == 1" style="color:#00b85c;">进行中</span>
                      <span v-else-if="scope.row.taskStatus == 2" style="color: red;">暂停</span>
                      <span v-else-if="scope.row.taskStatus == 3">完成</span>
                      <span v-else>-</span>
                    </span>
                    <span v-else-if="item.label == '下车发料时间' && currenindex == 2 && scope.$index != tableData1.length - 1">
                      <span :style="{ color: isExpired(scope.row.nextSendTime) ? 'red' : 'black' }">{{
                        scope.row.nextSendTime }}</span>
                    </span>
                    <span v-else-if="item.label == '修改人' && currenindex == 2 && scope.$index != tableData1.length - 1">
                      <span :style="{ color: isAllStop(scope.row.updateUserName) ? 'red' : 'black' }">{{
                        scope.row.updateUserName }}</span>
                    </span>
                    <span v-else-if="item.label == '非满载' && currenindex == 2 && scope.$index != tableData1.length - 1">
                      <el-switch v-model="scope.row.smallSquareMark" active-color="#13ce66" inactive-color="#ff4949"
                        :active-value="0" :inactive-value="1" @change="(val) => cancelLimit(scope.row, val)">
                      </el-switch>
                    </span>
                    <div
                      v-else-if="item.label == '发料通知' && showAll != 'table_1' && scope.$index != tableData1.length - 1">
                      <el-button size="mini" class="bottom_one" @click="look5_0Fun(scope.row)">查看</el-button>
                      <el-tag v-if="scope.row.planNoticeNum" type="danger" size="mini">{{ scope.row.planNoticeNum
                      }}</el-tag>
                    </div>
                    <span
                      v-else-if="item.label == '操作' && showAll != 'table_1' && scope.$index != tableData1.length - 1 && currenindex == 1">
                      <el-link v-if="tableParams1.orderStatus == 2" type="danger" :underline="false"
                        @click="cancelPlan(scope.row)"> 取消 </el-link>
                      <el-button v-if="tableParams1.orderStatus == 3" size="mini" style="margin-left: 0px"
                        class="bottom_three" @click="workStartEnd(4, scope.row)">完 工</el-button>
                      <el-link v-if="tableParams1.orderStatus == 4" type="success" :underline="false"
                        @click="workStartEnd(3, scope.row)"> 补单恢复 </el-link>
                    </span>
                    <span
                      v-else-if="item.label == '操作' && showAll != 'table_1' && scope.$index != tableData1.length - 1 && currenindex == 2">
                      <el-button v-if="scope.row.taskStatus == 1 || scope.row.taskStatus == 2" size="mini"
                        style="margin-left: 10px" class="bottom_three" @click="adjustTask(scope.row)">调整</el-button>
                      <el-link v-if="scope.row.taskStatus == 1 || scope.row.taskStatus == 2" type="danger"
                        :underline="false" style="margin-left: 10px" @click="updateTask(scope.row, 3)">完成</el-link>
                      <el-link v-if="scope.row.taskStatus == 2" type="success" style="margin-left: 10px"
                        :underline="false" @click="updateTask(scope.row, 1)">继续</el-link>
                      <el-link v-if="scope.row.taskStatus == 1" type="warning" style="margin-left: 10px"
                        :underline="false" @click="updateTask(scope.row, 2)">暂停</el-link>
                    </span>
                    <span v-else class="ellipsis-text">{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </el-table-draggable>
          <!-- <div class="card_bottom">
            <div class="card_bottom_left">
              <div class="top_page_totle">总共{{ tableParams1.total }}条</div>
              <el-pagination
                :current-page.sync="tableParams1.page"
                :page-size="tableParams1.pageSize"
                :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                layout="prev,pager,sizes,next,jumper"
                :total="tableParams1.total"
                @size-change="sizeChange"
                @current-change="gettableData()"
              ></el-pagination>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
            </div>
          </div> -->
        </div>
      </el-main>
    </el-container>
    <el-row>
      <el-col :span="14">
        <!-- 第二部分 -->
        <el-main style="padding:2px 20px 0px 20px; 0" class="table">
          <div>
            <div class="search">
              <span style="margin-right: 24px">
                <span style="margin-right: 12px; font-size: 24px">生产信息</span>
              </span>
              <span style="margin-right: 24px">
                <span style="margin-right: 12px">生产线</span>
                <el-select v-model="tableParams2.lineIds" style="width: 250px" multiple placeholder="请选择"
                  @change="getStationTaskList">
                  <el-option v-for="(item, index) in lineList" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="margin-right: 24px">
                <el-button size="small" class="bottom_all but1" @click="deleteTask()">作废</el-button>
              </span>
              <span style="margin-right: 24px">
                <el-checkbox v-model="printStatus" @change="changePrint">自动打印</el-checkbox>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1"
                :disabled="buttonStatus || !selectRow.id" @click="print()">打 印</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px"
                @click="openPrintSet()">打印设置</el-button>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table ref="tableData2" :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%"
              :height="Number(newScreenHeight * 5 / 12).toFixed(2) - 82" highlight-current-row :data="tableData2"
              show-overflow-tooltip tooltip-effect="dark" current-row-key="id" @current-change="handleCurrentChange">
              <template v-for="(item, index2) in table2">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="item.label == '状态'">
                      <span v-if="scope.row.handleStatus == 0">传输中</span>
                      <span v-else-if="scope.row.handleStatus == 1">成功</span>
                      <span v-else-if="scope.row.handleStatus == 2">失败</span>
                      <span v-else-if="scope.row.handleStatus == 3">不处理</span>
                      <span v-else>-</span>
                    </span>
                    <span v-else-if="item.label == '车辆'">
                      <span>{{ scope.row.carEmissionId ? (scope.row.carNo + '/' + scope.row.carEmissionId) :
                        scope.row.carNo }}</span>
                    </span>
                    <span v-else class="ellipsis-text">{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </el-main>
      </el-col>
      <el-col :span="10">
        <!-- 第三部分 -->
        <el-main style="padding:2px 20px 0px 20px; 0" class="table">
          <div>
            <div class="search">
              <div class="searchLeft">
                <span style="margin-right: 24px">
                  <span style="margin-right: 12px; font-size: 24px">车辆信息</span>
                </span>
              </div>
              <div class="searchRight">
                <el-button size="medium" class="bottom_all but1" @click="lineSetOpen()">生产线维护</el-button>
                <el-button size="medium" class="bottom_all but1" @click="carQueryOpen()">车辆查询</el-button>
                <el-button size="medium" class="bottom_all but1" @click="personOpen()">人员配置</el-button>
                <el-button size="medium" class="bottom_all but1" @click="addCar()">添 加</el-button>
              </div>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table ref="table3" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%"
              :height="Number(newScreenHeight * 5 / 12).toFixed(2) - 82" :data="tableData3New" tooltip-effect="dark"
              :span-method="arraySpanMethod">
              <template v-for="(item, index2) in table3">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :fixed="item.fixed"
                  :width="item.width">
                  <template slot-scope="scope">
                    <div v-if="scope.$index == 2 && item.prop !== 'lineName'" class="car">
                      <div v-for="(carItem, carIndex) in scope.row[item.prop]" :key="carIndex" style="margin-left: 10px">

                        <el-popover v-if="carItem.carEng.length > 0" :key="carIndex" :offset="100" placement="top"
                          :close-delay="100" width="260" trigger="hover">
                          <div class="outCarNos">
                            <span v-for="(engItem, engIndex) in carItem.carEng" :key="engIndex"
                              style="margin-left: 10px">{{ engItem }}</span>
                          </div>
                          <el-dropdown slot="reference" :hide-on-click="true" :disabled="carItem.carNo.indexOf('↑') != -1"
                            trigger="click">
                            <div :style="{color: checkCarEng(carItem.carNo)}">{{ carItem.carNo }}</div>
                            <el-dropdown-menu slot="dropdown" style="text-align: left">
                              <el-dropdown-item>
                                <el-link type="success" :underline="false"
                                  @click="addSequence(1, carItem.carNo, item.groupNum)">前移</el-link>
                              </el-dropdown-item>
                              <el-dropdown-item>
                                <el-link type="primary" :underline="false"
                                  @click="addSequence(2, carItem.carNo, item.groupNum)">置顶</el-link>
                              </el-dropdown-item>
                              <el-dropdown-item>
                                <el-link type="danger" :underline="false" @click="deleteCar(carItem.carNo)">删除</el-link>
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </el-popover>
                        <el-dropdown v-else slot="reference" :hide-on-click="true"
                          :disabled="carItem.carNo.indexOf('↑') != -1" trigger="click">
                          <div :style="{ color: checkCarEng(carItem.carNo)}">{{ carItem.carNo }}
                          </div>
                          <el-dropdown-menu slot="dropdown" style="text-align: left">
                            <el-dropdown-item>
                              <el-link type="success" :underline="false"
                                @click="addSequence(1, carItem.carNo, item.groupNum)">前移</el-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                              <el-link type="primary" :underline="false"
                                @click="addSequence(2, carItem.carNo, item.groupNum)">置顶</el-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                              <el-link type="danger" :underline="false" @click="deleteCar(carItem.carNo)">删除</el-link>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>

                      </div>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </el-main>
      </el-col>
    </el-row>
    <!-- 人员配置 -->
    <el-dialog :visible.sync="personDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">人员配置</span>
      <div class="dialoginfo" style="padding: 0">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="personData" tooltip-effect="dark">
          <el-table-column label="人员类型" align="center" prop="userType">
            <template slot-scope="scope">
              <span v-if="scope.row.userType == 1">操作员</span>
              <span v-else>调度员</span>
            </template>
          </el-table-column>
          <el-table-column label="生产线" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.userType == 1">{{ scope.row.lineName }}</span>
              <span v-else>/</span>
            </template>
          </el-table-column>
          <el-table-column label="人员" align="center">
            <template slot-scope="scope">
              <el-select :ref="'userId' + scope.$index" v-model="scope.row.userId" @change="
                $nextTick(() => {
                  scope.row.userName = $refs[`userId${scope.$index}`].selectedLabel;
                })
                ">
                <el-option v-for="(item, index) in personList" :key="index" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="personDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="savePerson()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 车辆查询 -->
    <el-dialog :visible.sync="carQueryDig" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">车辆查询</span>
      <div class="dialoginfo" style="padding: 0">
        <div class="carSearch">
          <span style="display: inline-block">
            <span style="margin-right: 12px">日期</span>
            <el-date-picker v-model="carQueryParams.carQueryTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"> </el-date-picker>
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">车牌号</span>
            <el-input v-model="carQueryParams.carNo" style="width: 150px" placeholder="请输入" clearable />
          </span>
          <el-button style="margin-left: 12px" icon="el-icon-search" size="mini" class="bottom_all"
            @click="(carQueryParams.page = 1), carQuery()">查
            询</el-button>
          <el-button class="bottom_all_two" size="mini" style="margin-left: 12px" @click="init()">重 置</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="carQueryData" tooltip-effect="dark">
          <el-table-column label="站点" align="center" prop="carStation">
          </el-table-column>
          <el-table-column label="车牌号" align="center" prop="carNo">
          </el-table-column>
          <el-table-column label="累计车次" align="center" prop="sumNum">
          </el-table-column>
          <el-table-column label="累计方量" align="center" prop="sumFaceValue">
          </el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ carQueryParams.total }}条</div>
            <el-pagination :current-page.sync="carQueryParams.page" :page-size="carQueryParams.pageSize"
              :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
              :total="carQueryParams.total" @size-change="carQuerySizeChange"
              @current-change="carQuery()"></el-pagination>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
              @click="gettableData">刷新</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="carQueryDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 打票机打印 -->
    <el-dialog :visible.sync="printSetDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 打印设置</span>
      <div class="dialoginfo" style="padding: 0">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="printSetData" tooltip-effect="dark">
          <el-table-column label="生产线" align="center" prop="name"> </el-table-column>
          <el-table-column label="本地打印机" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.printerName" style="width: 180px" placeholder="请输入打印机名称"
                @change="savePrintSet(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="打票机" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.ticketMachineConfigure" active-color="#13ce66" inactive-color="#ff4949"
                active-value="1" inactive-value="0" @change="savePrintSet(scope.row)"> </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="printSetDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 产品选择 -->
    <el-dialog :visible.sync="productDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">砂浆及非配方选择 </span>
      <div class="dialoginfo" style="padding: 0">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="productList" tooltip-effect="dark" highlight-current-row
          @current-change="currentProduct">
          <el-table-column label="品种" align="center" prop="productName"> </el-table-column>
          <el-table-column label="是否传工控" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.whetherSend == 0">否</span>
              <span v-if="scope.row.whetherSend == 1">是</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="productDig = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="confirmProduct()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 发料 -->
    <el-dialog :visible.sync="issueGoodsDig" width="750px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">发料</span>
      <div v-loading="saveload" class="dialoginfo">
        <el-form ref="reffromData" :rules="rules" :inline="true" :model="formData" label-width="110px">
          <el-form-item prop="engineeringName">
            <span slot="label">工程名称</span>
            <el-input v-model="formData.engineeringName" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item prop="productionSite">
            <span slot="label">站点名称</span>
            <el-input v-model="formData.productionSite" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item prop="pouringMethod">
            <span slot="label">浇筑方式</span>
            <el-input v-model="formData.pouringMethod" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item prop="structuralParts">
            <span slot="label">浇筑部位</span>
            <el-input v-model="formData.structuralParts" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item prop="productName">
            <span slot="label">产品名称</span>
            <el-input v-model="formData.productName" style="width: 175px" :disabled="true" placeholder="请输入">
            </el-input><el-link type="success" style="margin-left: 10px" :underline="false"
              @click="productDig = true">选择</el-link>
          </el-form-item>
          <el-form-item prop="proLineId">
            <span slot="label">生产线</span>
            <el-select ref="proLineId" v-model="formData.proLineId" style="width: 215px" placeholder="请选择" filterable>
              <el-option v-for="item in lineList" :key="item.id" :label="item.name" :value="item.id"
                @click.native="queryCarData(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">操作员</span>
            <el-select ref="operatorId" v-model="formData.operatorId" style="width: 215px" placeholder="请选择"
              :disabled="true" @change="
                $nextTick(() => {
                  formData.operator = $refs.operatorId.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in peoplelist" :key="index" :label="item.userName"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="carNo">
            <span slot="label">车辆</span>
            <el-select v-model="formData.carNo" style="width: 215px" placeholder="请选择" filterable>
              <el-option v-for="(item, index) in carList" :key="index" :label="item.carNo" :value="item.carNo"
                :style="{ color: item.oddmentsNum > 0 ? 'red' : '' }" @click.native="selectCar(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">驾驶员</span>
            <el-input v-model="formData.driverName" style="width: 215px" :disabled="true" placeholder="请输入"> </el-input>
          </el-form-item>
          <el-form-item prop="faceValue">
            <span slot="label">货票量</span>
            <el-input v-model="formData.faceValue" :disabled="!formData.carNo" style="width: 215px" placeholder="请输入"
              @input="formData.faceValue = $regExp.checkNum(formData.faceValue)"
              @blur="formData.faceValue = $regExp.blurCheckNum(formData.faceValue)" @change="inputFaceValue"> </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">转入量</span>
            <el-input v-model="formData.transferAmount" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">富余量</span>
            <el-input v-model="formData.lossNum" style="width: 150px" :disabled="true" placeholder="请输入">
            </el-input><el-switch v-model="formData.whetherCalculateTheSurplus" style="margin-left:5px"
              active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"
              @change="inputFaceValue">
            </el-switch>
          </el-form-item>
          <el-form-item prop="proNum">
            <span slot="label">生产方量</span>
            <el-input v-model="formData.proNum" type="number" :step="0.01" min="0" :disabled="!formData.carNo"
              style="width: 215px" placeholder="请输入" @input="formData.proNum = $regExp.checkNum(formData.proNum)"
              @blur="formData.proNum = $regExp.blurCheckNum(formData.proNum)">
            </el-input>
          </el-form-item>
          <el-form-item prop="distance">
            <span slot="label">运距</span>
            <el-input v-model="formData.distance" type="number" :step="0.01" min="0" style="width: 215px"
              placeholder="请输入" @input="formData.distance = $regExp.checkNum(formData.distance)"
              @blur="formData.distance = $regExp.blurCheckNum(formData.distance)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="formData.remark" :rows="1" resize="none" style="width: 550px" type="textarea"
              placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeGoods()">取 消</el-button>
        <!-- <el-button class="bottom_all_two" @click="issueGoodsDig = false">取 消</el-button> -->
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveIssueGoods()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 自动发料 -->
    <el-dialog :visible.sync="autoIssueGoodsDig" width="820px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">自动发料</span>
      <div v-loading="saveload" class="dialoginfo">
        <el-form ref="autoFormData" :rules="autoRules" :inline="true" :model="autoFormData" label-width="140px">
          <el-form-item>
            <span slot="label">工程名称</span>
            <el-input v-model="autoFormData.engineeringName" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">站点名称</span>
            <el-input v-model="autoFormData.stationName" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">浇筑方式</span>
            <el-input v-model="autoFormData.pouringMethod" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">浇筑部位</span>
            <el-input v-model="autoFormData.structuralParts" style="width: 215px" :disabled="true" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">产品名称</span>
            <el-input v-model="autoFormData.product" style="width: 175px" :disabled="true" placeholder="请输入">
            </el-input><el-link type="success" style="margin-left: 10px" :underline="false"
              @click="productDig = true">选择</el-link>
          </el-form-item>
          <el-form-item prop="planNum">
            <span slot="label">发料总方量</span>
            <el-input v-model="autoFormData.planNum" style="width: 215px" placeholder="请输入"
              @input="autoFormData.planNum = $regExp.checkNum(autoFormData.planNum)"
              @blur="autoFormData.planNum = $regExp.blurCheckNum(autoFormData.planNum)"> </el-input>
          </el-form-item>
          <el-form-item prop="planStartTime">
            <span slot="label">计划开始发料时间</span>
            <el-date-picker v-model="autoFormData.planStartTime" style="width: 215px" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item prop="sendFrequency">
            <span slot="label">间隔时间</span>
            <el-select ref="sendFrequency" v-model="autoFormData.sendFrequency" style="width: 215px" placeholder="请选择"
              filterable>
              <el-option v-for="item in sendFrequencyList" :key="item.itemValue" :label="item.itemName"
                :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="whetherCalculateThesurplus">
            <span slot="label">是否计算富余量</span>
            <el-radio-group v-model="autoFormData.whetherCalculateThesurplus">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="autoFormData.remark" :rows="1" resize="none" style="width: 550px" type="textarea"
              placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="cumulativeData" tooltip-effect="dark">
          <el-table-column label="站点" align="center" prop="stationName" width="133"></el-table-column>
          <el-table-column label="累计车数" align="center" prop="cumulativeCar"></el-table-column>
          <el-table-column label="累计方量" align="center" prop="CumulativeUseNum"></el-table-column>
        </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeAutoGoods()">取 消</el-button>
        <!-- <el-button class="bottom_all_two" @click="issueGoodsDig = false">取 消</el-button> -->
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveAutoIssueGoods()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 自动发料调整 -->
    <el-dialog :visible.sync="autoGoodsUpdateDig" width="820px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">调整</span>
      <div v-loading="saveload" class="dialoginfo">
        <el-form ref="autoUpdateFormData" :rules="autoUpdateRules" :inline="true" :model="autoUpdateFormData"
          label-width="140px">
          <el-form-item prop="planNum">
            <span slot="label">计划开始发料量</span>
            <el-input v-model="autoUpdateFormData.planNum" style="width: 215px" placeholder="请输入"
              @input="autoUpdateFormData.planNum = $regExp.checkNum(autoUpdateFormData.planNum)"
              @blur="autoUpdateFormData.planNum = $regExp.blurCheckNum(autoUpdateFormData.planNum)"> </el-input>
          </el-form-item>
          <el-form-item prop="sendFrequency">
            <span slot="label">间隔时间</span>
            <el-select ref="sendFrequency" v-model="autoUpdateFormData.sendFrequency" style="width: 215px"
              placeholder="请选择" filterable>
              <el-option v-for="item in sendFrequencyList" :key="item.itemValue" :label="item.itemName"
                :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="planStartTime">
            <span slot="label">原计划时间</span>
            <el-date-picker v-model="autoUpdateFormData.planStartTime" :disabled="true" style="width: 215px"
              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item prop="nextSendTime">
            <span slot="label">调整时间</span>
            <el-date-picker v-model="autoUpdateFormData.nextSendTime" style="width: 215px" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item prop="whetherCalculateThesurplus">
            <span slot="label">是否计算富余量</span>
            <el-radio-group v-model="autoUpdateFormData.whetherCalculateThesurplus">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="autoUpdateFormData.remark" :rows="1" resize="none" style="width: 550px" type="textarea"
              placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="cumulativeData" tooltip-effect="dark">
          <el-table-column label="站点" align="center" prop="stationName" width="133"></el-table-column>
          <el-table-column label="累计车数" align="center" prop="cumulativeCar"></el-table-column>
          <el-table-column label="累计方量" align="center" prop="CumulativeUseNum"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeAutoGoodsUpdate()">取 消</el-button>
        <!-- <el-button class="bottom_all_two" @click="issueGoodsDig = false">取 消</el-button> -->
        <el-button class="bottom_all" style="margin-left: 24px" @click="AutoIssueGoodsUpdate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加车辆排队 -->
    <el-dialog :visible.sync="addCarDig" width="1080px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">车辆排队</span>
      <div v-loading="saveload" class="dialoginfo">
        <el-form ref="carForm" :rules="carRules" :inline="true" :model="carForm" label-width="110px">
          <el-form-item prop="queueUpLineGroup">
            <span slot="label">生产线</span>
            <el-select ref="queueUpLineGroup" v-model="carForm.queueUpLineGroup" style="width: 215px" placeholder="请选择"
              filterable @change="
                $nextTick(() => {
                  carForm.queueUpLine = $refs.queueUpLineGroup.selectedLabel;
                })
                ">
              <el-option v-for="item in lineGroupList" :key="item.groupNum" :label="item.name"
                :value="item.groupNum"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="carNo">
            <span slot="label">车牌号</span>
            <el-select v-model="carForm.carNo" style="width: 215px" placeholder="请选择" filterable>
              <el-option v-for="(item, index) in waitLineUpCarsList" :key="index" :label="item.carNo" :value="item.carNo"
                @click.native="
                  carForm.carNoCode = item.carNoCode;
                carForm.userName = item.userName || '';
                "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">驾驶员</span>
            <el-input v-model="carForm.userName" style="width: 215px" :disabled="true" placeholder="请输入"> </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addCarDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveCarAdd()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 发料通知 -->
    <el-dialog v-dialogDrag :visible.sync="formData5Type" width="1140px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">发料通知</span>
      <div class="dialoginfo">
        <div class="FZYulli">
          <div style="margin-bottom: 5px">工程名称：{{ formData5.engineeringName }}</div>
          <div style="margin-bottom: 5px">订单编号：{{ formData5.orderNo }}</div>
          <div style="margin-bottom: 5px">产品名称：{{ formData5.productName }}</div>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="formData5.list" tooltip-effect="dark">
          <el-table-column label="创建时间" align="center" prop="createTime" width="133"></el-table-column>
          <el-table-column label="创建人" align="center" prop="createUserUame"></el-table-column>
          <el-table-column label="修改人" align="center" prop="updateUserName"></el-table-column>
          <el-table-column label="修改时间" align="center" prop="updateTime"></el-table-column>
          <el-table-column label="计划发料时间" align="center" prop="planStartTime" width="133"></el-table-column>
          <el-table-column label="计划发料量" align="center" prop="theRestNum"></el-table-column>
          <el-table-column label="间隔时间" align="center" prop="sendFrequency"></el-table-column>
          <el-table-column label="产品名" align="center" prop="product"></el-table-column>
          <el-table-column label="任务状态" align="center" prop="taskStatus"></el-table-column>
          <el-table-column label="累计方量" align="center" prop="sumSendNum"></el-table-column>
          <el-table-column label="累计车次" align="center" prop="carNum"></el-table-column>
          <el-table-column label="操作日志" align="center" prop="operateResordList"></el-table-column>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ formData5Param.total }}条</div>
          <el-pagination :current-page.sync="formData5Param.page" :page-size="formData5Param.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
            :total="formData5Param.total" @size-change="formData5SizeChange"
            @current-change="queryNotepage()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="queryNotepage">刷新</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="formData5Type = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 生产线维护 -->
    <el-dialog :visible.sync="lineSetDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 生产线维护</span>
      <div class="dialoginfo" style="padding: 0">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="lineSetData" tooltip-effect="dark">
          <el-table-column label="生产线" align="center" prop="name"> </el-table-column>
          <el-table-column label="运行状态" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.runningState" active-color="#13ce66" inactive-color="#ff4949" active-value="1"
                inactive-value="2" @change="updateLine(scope.row)"> </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="指定车辆类型" align="center">
            <template slot-scope="scope">
              <el-select ref="carType" v-model="scope.row.carNoTypes" placeholder="请选择" multiple @change="updateLine(scope.row)">
              <el-option key="1" label="新能源" value="1"></el-option>
              <el-option key="2" label="油车" value="2"></el-option>
              <el-option key="3" label="拖挂车" value="3"></el-option>
              <el-option key="4" label="外租燃油罐车" value="4"></el-option>
              <el-option key="5" label="外租新能源罐车" value="5"></el-option>
            </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="lineSetDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 打印组件 -->
    <Printer ref="printer" :data="printData" :firstKey="'concreteCarTicketMain'" :secondKey="'concreteDriverTicket'"
      :stationId="stationInfo.id" :userSelectIndex="templateId" :printerName="printerName"
      @closeDialog="getStationTaskList"></Printer>
    <!-- 批量打印组件 -->
    <!-- <PrinterBatch ref="PrinterBatch" :key="printDialog" :printBatchData="printBatchData"
      :firstKey="'concreteCarTicketMain'" :secondKey="'concreteDriverTicket'" :stationId="stationInfo.id"
      :userSelectIndex="templateId" :printerName="printerName"></PrinterBatch> -->
    <!-- 累计车辆弹窗 -->
    <carDetail :visible.sync="carDetailDig" :config="low" :printSetData="printSetData" :carType="carType" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryUserByOrganization,
  savePeople,
  queryPeople,
  queryLineByStation,
  queryPlanList,
  updatePlan,
  cancelPlan,
  queryOtherData,
  queryCarData,
  queryStationTaskList,
  deleteTask,
  queryTicketMachineCon,
  updateTicketConfig,
  queryLineGroup,
  queryWaitLineUpCars,
  saveNewTankerUp,
  movePosition,
  deleteTanekrUp,
  sendMaterials,
  saveProDispatch,
  queryCarpage,
  querySpecailProduct,
  addAutoSendMaterial,
  queryTaskList,
  updateTask,
  adjustTask,
  queryNotepage,
  cancelLimit,
  updateLine,
  pauseAllTask,
  queryEngeningCars,
  updatePlanMaxCarNum,
  queryChildSum
} from "@/api/smart/productTransport_outside.js";
import { updateNotice } from "@/api/smart/schedul/j.js";
import { getDicType } from "@/api/common";
import { _debounce } from "@/utils/utils.js";
import Printer from "@/views/components/Printer.vue";
// import PrinterBatch from "@/views/components/PrinterBatch.vue";
import carDetail from "@/views/platform/ICPS/smart/schedul/components/carDetail";
import ElTableDraggable from 'el-table-draggable'
export default {
  mixins: [mixin],
  components: {
    Printer,
    // PrinterBatch,
    carDetail,
    ElTableDraggable
  },
  data() {
    return {
      UserInfo: "",
      headerImage: "",
      printStatus: false,
      maxCarWidth: "1320",
      stationInfo: "",
      newScreenHeight: 0,
      tableParams1: {
        stationId: "",
        productName: "",
        pourTime: "",
        orderStatus: "3",
      },
      tableParams4: {
        stationId: "",
        product: "",
        taskStatus: "1",
        planStartTime: "",
      },
      tableParams2: {
        productionSiteId: "",
        lineIds: [],
      },
      tableParams3: {
        stationId: "",
        engineeringName: "",
        orderNo: "",
        carNo: "",
        page: 1,
        pageSize: 10,
        total: 0,
      },
      oderStatusList: [
        {
          value: "2",
          name: "待开工",
        },
        {
          value: "3",
          name: "生产中",
        },
        {
          value: "4",
          name: "已完成",
        },
      ],
      taskStatusList: [
        // {
        //   value: "0",
        //   name: "取消",
        // },
        {
          value: "1",
          name: "进行中",
        },
        {
          value: "3",
          name: "已完成/取消",
        },
        {
          value: "",
          name: "全部",
        },
      ],
      table1: [],
      //待开工
      table1_1: [
        // { label: "订单号", prop: "orderNo", status: true, width: "150" },
        // { label: "站点名称", prop: "stationName", status: true, width: "70" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "135" },
        { label: "客户单位", prop: "customerName", status: true, width: "200" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "100" },
        { label: "计划量", prop: "planNum", status: true, width: "60" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "结算方式", prop: "settleMethod", status: true, width: "100" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "70" },
        { label: "发料通知", prop: "planNoticeNum", status: true, width: "100" },
        { label: "开工", prop: "", status: true, width: "80", fixed: "left" },
        { label: "操作", prop: "", status: true, width: "80", fixed: "right" },
      ],
      //生产中
      table1_2: [
        { label: "发料", prop: "send", status: true, width: "180" },
        { label: "优先等级", prop: "transportSort", status: true, width: "85", align: "left" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "135" },
        // { label: "订单号", prop: "orderNo", status: true, width: "150" },
        // { label: "站点名称", prop: "stationName", status: true, width: "70" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "客户单位", prop: "customerName", status: true, width: "200" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "100" },
        { label: "计划量", prop: "planNum", status: true, width: "60" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "结算方式", prop: "settleMethod", status: true, width: "100" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "100" },
        { label: "在外车辆", prop: "outCarNoCount", status: true, width: "70" },
        { label: "在外车辆设置", prop: "maxOutCarNoCount", status: true, width: "100" },
        { label: "发料通知", prop: "planNoticeNum", status: true, width: "100" },
        { label: "操作", prop: "", status: true, width: "80" },
      ],
      table1_3: [
        // { label: "订单号", prop: "orderNo", status: true, width: "220" },
        // { label: "站点名称", prop: "stationName", status: true, width: "70" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "135" },
        { label: "客户单位", prop: "customerName", status: true, width: "200" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "140" },
        { label: "计划量", prop: "planNum", status: true, width: "60" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "结算方式", prop: "settleMethod", status: true, width: "100" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "70" },
        { label: "在外车辆", prop: "outCarNoCount", status: true, width: "70" },
        { label: "发料通知", prop: "planNoticeNum", status: true, width: "100" },
        { label: "操作", prop: "", status: true, width: "80", fixed: "left" },
      ],
      //自动发料
      table1_4: [
        { label: "状态", prop: "taskStatus", status: true, width: "58" },
        { label: "优先等级", prop: "sortNum", status: true, width: "85", align: "left" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "工程名称", prop: "engineeringName", status: true, width: "220" },
        { label: "浇筑部位", prop: "pourPart", status: true, width: "auto" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "140" },
        { label: "产品名称", prop: "product", status: true, width: "80" },
        { label: "计划量", prop: "planNum", status: true, width: "58" },
        { label: "间隔时间", prop: "sendFrequency", status: true, width: "70" },
        { label: "通知发料时间", prop: "planStartTime", status: true, width: "134" },
        { label: "下车发料时间", prop: "nextSendTime", status: true, width: "134" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "100" },
        // { label: "子订单号", prop: "planCode", status: true, width: "70" },
        { label: "在外车辆", prop: "outCarNoCount", status: true, width: "70" },
        { label: "在外车辆设置", prop: "maxOutCarNum", status: true, width: "93" },
        { label: "创建人", prop: "createUserName", status: true, width: "70" },
        { label: "修改人", prop: "updateUserName", status: true, width: "70" },
        { label: "非满载", prop: "", status: true, width: "70" },
        { label: "操作", prop: "", status: true, width: "170" },
      ],
      table2: [
        { label: "状态", prop: "handleStatus", status: true, width: "80" },
        { label: "生产线", prop: "proLine", status: true, width: "80" },
        { label: "车辆", prop: "carNo", status: true, width: "90" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "产品名称", prop: "strengthGrade", status: true, width: "80" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "130" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "票面量", prop: "faceValue", status: true, width: "70" },
        { label: "生产方量", prop: "proNum", status: true, width: "70" },
        { label: "创建时间", prop: "createTime", status: true, width: "135" },
      ],
      table3: [
        { label: " 生产线", prop: "logisticsCode", status: true, width: "110", fixed: true },
        { label: "装料", prop: "productionSite", status: true, width: "auto ", fixed: true },
        { label: "排队", prop: "engineeringName", status: true, width: "400" },
      ],
      tableData1: [],
      table1Load: false,
      tableData2: [],
      tableData3New: [],
      tableData3: [],
      stationList: [],
      transportSortList: [],
      lineList: [],
      //人员配置-开始
      personDig: false,
      personData: [
        { userType: 1, userId: [], userName: "", lineId: "", lineName: "", stationId: "", id: "" },
        { userType: 2, userId: [], userName: "", lineId: "", lineName: "", stationId: "", id: "" },
      ],
      personList: [],
      //人员配置-结束
      //发料-开始
      formData: {
        id: "",
        planId: "", //计划id
        engineeringName: "", //工程名称
        productionSite: "", //生产站点
        productionSiteId: "", //生产站点id
        proLine: "", //生产线
        proLineId: "", //生产线id
        proLineCode: "", //生产线code
        whetherSend: 1, //是否发送到工控系统:0否；1是；
        operator: "", //操作员
        operatorId: "", //操作员ID
        carNo: "", //车牌号
        driverName: "", //司机名称
        driverId: "", //司机id
        driverPhone: "", //司机电话
        faceValue: 0, //票面量
        transferAmount: 0, //转入量
        lossNum: 0, //富余量
        proNum: 0, //生产量
        productName: "", //产品名称
        pouringMethod: "", //浇筑方式
        structuralParts: "", //浇筑部位
        remark: "", //计划备注
        whetherSpecialPeoduct: 0, //是否选择特殊产品
      },
      carPlan: "",
      rules: {
        proLineId: [{ required: true, message: "请选择生产线", trigger: "change" }],
        operatorId: [{ required: true, message: "请选择操作员", trigger: "change" }],
        carNo: [{ required: true, message: "请选择车辆", trigger: "change" }],
        faceValue: [{ required: true, message: "请输入货票量", trigger: "blur" }],
        proNum: [{ required: true, message: "请输入生产量", trigger: "blur" }],
      },
      autoRules: {
        planNum: [{ required: true, message: "请输入发料总方量", trigger: "blur" }],
        sendFrequency: [{ required: true, message: "请选择间隔时间", trigger: "change" }],
        planStartTime: [{ required: true, message: "请选择发料时间", trigger: "change" }],
      },
      autoUpdateRules: {
        planNum: [{ required: true, message: "请输入发料总方量", trigger: "blur" }],
        sendFrequency: [{ required: true, message: "请选择间隔时间", trigger: "change" }],
        nextSendTime: [{ required: true, message: "请选择发料时间", trigger: "change" }],
        whetherCalculateThesurplus: [{ required: true, message: "请选择是否计算富余量", trigger: "change" }],
      },
      issueGoodsDig: false,
      carList: [],
      peoplelist: [],
      productList: [],
      //发料-结束
      //自动发料
      autoFormData: {
        planId: "",
        planCode: "",
        stationName: "",
        stationId: "",
        product: "",
        whetherSpecialPeoduct: 0,//是否特殊产品：0否；1是
        whetherSend: 1,//是否发送到工控系统:0否；1是；
        planNum: "",//计划发料量
        sendFrequency: "",//发料间隔时间
        planStartTime: "",//计划发料时间
        handleStatus: 4,//状态 4不传输
        whetherCalculateThesurplus: "",
        remark: "",
      },
      autoUpdateFormData: {
        id: "",
        planNum: '',//计划量
        sendFrequency: '',//时间间隔
        nextSendTime: "", //下车发料时间
        whetherCalculateThesurplus: "", //是否计算富余量
        remark: "", //备注
      },
      sendFrequencyList: [],
      autoIssueGoodsDig: false,
      autoGoodsUpdateDig: false,
      //生产任务开始
      selectRow: {},
      printSetData: [],
      printSetDig: false,
      //生产任务结束
      addCarDig: false,
      carForm: {
        carNo: "",
        stationId: "",
        queueUpLine: "", //排队生产线名称
        queueUpLineGroup: "", //排队生产线分组
        carNoCode: "",
        userName: "",
      },
      carRules: {
        queueUpLineGroup: [{ required: true, message: "请选择生产线", trigger: "change" }],
        carNo: [{ required: true, message: "请选择车辆", trigger: "change" }],
      },
      lineGroupList: [],
      waitLineUpCarsList: [],
      saveload: false,
      //websock
      websock: "",
      fourNumber: null, // 随机四位数
      time: null,
      setTime: null,
      count: 0,
      low: {},
      //打印
      printData: [],
      printBatchData: [],
      templateId: "",
      printDialog: false,
      //选择产品配方
      productDig: false,
      selectProduct: {},
      carDetailDig: false,
      //打印计时器
      printTime: "",
      printerName: "",
      buttonStatus: false,
      stationTaskListTime: "",
      planListTime: "",
      //发料通知
      formData5Type: false,
      formData5: {},
      showAll: 'table1_2',//是否显示合计
      //车辆查询
      carQueryDig: false,
      carQueryData: [],
      carQueryParams: {
        page: 1,
        pageSize: 10,
        stationId: "",
        endQueryTime: "",
        startQueryTime: "",
        carQueryTime: [],
        carNo: "",
        total: 0,
      },
      tabList: [
        {
          value: "传统发料",
          status: 1,
        },
        {
          value: "自动发料",
          status: 2,
        },
      ],
      currenindex: 1,
      carType: 1,
      formData5Param: {
        page: 1,
        pageSize: 10,
        engId: "",
      },
      isMaterialIssue: false,
      now: new Date(),
      carTimer: "",
      lineSetDig: false,
      lineSetData: [],
      engCar: [],
      engBycar: [],
      columKey: 0,
      cumulativeData:[],
    };
  },
  async created() {
    let stationUserInfo = JSON.parse(window.sessionStorage.getItem("stationUserInfo"));
    console.log(stationUserInfo);
    this.UserInfo = stationUserInfo.UserInfo;
    this.headerImage = this.UserInfo.headImg ? `/file/${this.UserInfo.headImg}` : "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
    this.stationInfo = stationUserInfo.stationInfo;
    this.tableParams1.stationId = this.stationInfo.id;
    this.tableParams4.stationId = this.stationInfo.id;
    this.tableParams2.productionSiteId = this.stationInfo.id;
    this.tableParams1.pourTime = new Date().Format("yyyy-MM-dd 00:00:00");
    // this.tableParams4.planStartTime = new Date().Format("yyyy-MM-dd 00:00:00");
    this.queryPlanList();
    //获取生产线
    queryLineByStation({ stationId: this.stationInfo.id }).then(res => {
      if (res.code == 1001) {
        this.lineList = res.data;
        //默认选择全部站点
        res.data.forEach(item => {
          this.tableParams2.lineIds.push(item.id);
        });
        this.getStationTaskList();
        this.stationTaskListTime = "";
        this.stationTaskListTime = setInterval(this.getStationTaskList, 20000);
        this.planListTime = "";
        this.planListTime = setInterval(this.queryPlanList, 20000);
      }
    });
    this.queryTicketMachineCon();
    //获取工艺流程生产线
    queryLineGroup({ stationId: this.stationInfo.id }).then(res => {
      if (res.code == 1001) {
        this.lineGroupList = res.data;
        this.lineGroupList.forEach(item => {
          let lineList = JSON.parse(item.lineName);
          item["lineList"] = lineList;
          item["name"] = lineList.map(item => item.name).join(",");
        });
      }
    });
    //获取人员
    queryUserByOrganization({ organizationId: this.stationInfo.id }).then(res => {
      if (res.code == 1001) {
        this.personList = res.data;
      }
    });
    //获取字典
    getDicType({ code: "transportSort" }).then(res => {
      this.transportSortList = res.data.items;
    });
    getDicType({ code: "IntervalTime" }).then(res => {
      this.sendFrequencyList = res.data.items;
    });
    //websock获取车辆信息
    if (this.websock) {
      this.websock.close();
    }
    this.fourNumber = this.generateRandomFourDigitNumber();
    this.initWebSocket();
    //默认生产中
    this.newScreenHeight = document.documentElement.clientHeight;
    this.table1 = this.table1_2;
  },
  watch: {},
  mounted() {
    //用于判断自动发料时间是否小于当前系统时间
    this.carTimer = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeDestroy() {
    if (this.websock) {
      this.websock.close();
      console.log("close socket");
    }
    if (this.printTime) {
      clearInterval(this.printTime);
    }
    if (this.stationTaskListTime) {
      clearInterval(this.stationTaskListTime);
    }
    if (this.planListTime) {
      clearInterval(this.planListTime);
    }
    if (this.carTimer) {
      clearInterval(this.carTimer);
    }
  },
  destroyed() {
    this.websock.close();
  },
  methods: {
    changeMaxOutCarNum(row) {
      updatePlanMaxCarNum({ id: row.planId, maxOutCarNum: row.maxOutCarNoCount == '' ? null : row.maxOutCarNoCount }).then(res => {
        if (res.code == 1001) {
          this.queryPlanList()
        }
      })
    },
    //判断车辆是否绑定工程
    checkCarEng(carNo) {
      console.log(`output->carNo`,carNo)
      let colorStr = '#606266'
      console.log(`output->this.engCar`,this.engCar)
      if(this.engCar.length > 0) {
        // 确保 carLists 不是 undefined 再调用 find
        let carLists = this.deduplicateCars(this.engCar)
        console.log(`output->carLists `,carLists )
        let carItem = carLists.find(item => carNo.includes(item.carNo))
        console.log(`output->carItem`,carItem)
        if(carItem && carItem.type ==1) {
          colorStr = 'red'
        } else if(carItem && carItem.type ==2){
          colorStr = 'green'
        } else {
          colorStr = '#606266'
        }
      }
      return colorStr
    },
    // 对engBycar数组去重，优先保存type为2的数据
    deduplicateCars(cars) {
      const carMap = new Map();
      cars.forEach(car => {
        const existingCar = carMap.get(car.carNo);
        if (car.type == 2 || !existingCar) {
          carMap.set(car.carNo, car);
        }
        else if (existingCar.type === 1 && car.type === 2) {
          carMap.set(car.carNo, car);
        }
      });
      return Array.from(carMap.values());
    },
    setPlanStartTime() {
      if (this.tableParams4.taskStatus == 1) {
        this.tableParams4.planStartTime = ''
      } else {
        this.tableParams4.planStartTime = new Date().Format("yyyy-MM-dd 00:00:00");
      }
    },
    getLineData() {
      queryLineByStation({ stationId: this.stationInfo.id }).then(res => {
        if (res.code == 1001) {
          res.data.forEach(item => {
            item['carNoTypes'] = item.carNoType?.split(',')
          })
          this.lineSetData = res.data
        }
      });
    },
    updateLine(row) {
      updateLine({ id: row.id, runningState: row.runningState,carNoTypes:row.carNoTypes })
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
          } else {
            this.getLineData();
          }
        })
        .catch(() => {
          this.getLineData();
        });
    },
    //判断自动发料时间
    isExpired(timeStr) {
      const time = new Date(timeStr);
      return time < this.now;
    },
    //判断自动发料时间
    isAllStop(name) {
      return name.indexOf("全停") == -1
    },
    //车辆信息开始
    initCarQuery() {
      this.carQueryParams = this.$options.data().carQueryParams
      this.carQueryParams.stationId = this.stationInfo.id
      let currentDate = new Date();
      let startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - 3);
      this.carQueryParams.carQueryTime = [startDate.Format('yyyy-MM-dd hh:mm:ss'), currentDate.Format('yyyy-MM-dd hh:mm:ss')]
    },
    carQuery() {
      if (this.carQueryParams.carQueryTime.length > 0) {
        this.carQueryParams.startQueryTime = this.carQueryParams.carQueryTime[0]
        this.carQueryParams.endQueryTime = this.carQueryParams.carQueryTime[1]
      } else {
        this.$message.warning('日期不能为空!')
        return
      }
      let _this = this
      queryCarpage(this.carQueryParams).then(res => {
        if (res.code == 1001) {
          _this.$set(_this, 'carQueryData', res.data.data)
          _this.carQueryParams.total = res.data.totalRows
        }
      })
    },
    carQuerySizeChange(value) {
      this.carQueryParams.pageSize = value;
      this.carQuery();
    },
    carQueryOpen() {
      this.initCarQuery()
      this.carQueryDig = true
      this.carQuery()
    },
    //车辆信息结束
    rowClassName(data) {
      if (data.rowIndex == this.tableData1.length - 1) {
        return "sumRow";
      }
    },
    //发料通知
    look5_0Fun(e) {
      this.low = e;
      this.formData5Type = true;
      this.formData5.engineeringName = e.engineeringName;
      this.formData5.orderNo = e.orderNo;
      this.formData5.productName = e.productName;
      this.formData5Param.planId = e.planId
      this.queryNotepage();
    },
    queryNotepage() {
      queryNotepage(this.formData5Param).then(res => {
        this.formData5.list = [];
        this.formData5.list = res.data.data;
        this.formData5Param.total = res.data.totalRows;
      });
    },
    formData5SizeChange(value) {
      this.formData5Param.pageSize = value;
      this.queryNotepage();
    },
    handleSubmit(data) {
      this.$confirm("该发料是否已在erp中安排生产?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        updateNotice({ id: data.id, handleStatus: 1 }).then(res => {
          if (res.code === 1001) {
            this.$message.success("操作成功");
            this.look5_0Fun(this.low);
          }
        });
      });
    },
    queryWaitLineUpCars() {
      //车辆排队获取车辆列表
      queryWaitLineUpCars({ stationId: this.stationInfo.id }).then(res => {
        if (res.code == 1001) {
          this.waitLineUpCarsList = res.data;
        }
      });
    },
    ToViewTypeFun(row, carType) {
      this.low = row;
      this.carDetailDig = true;
      this.carType = carType
    },
    currentProduct(val) {
      this.selectProduct = val;
    },
    confirmProduct() {
      this.formData.productName = this.selectProduct.productName;
      this.autoFormData.product = this.selectProduct.productName;
      this.formData.whetherSend = this.selectProduct.whetherSend * 1;
      this.autoFormData.whetherSend = this.selectProduct.whetherSend * 1;
      this.formData.whetherSpecialPeoduct = 1;
      this.autoFormData.whetherSpecialPeoduct = 1;
      this.productDig = false;
    },
    //websock  开始
    initWebSocket() {
      //初始化weosocket
      //  const wsuri = `${process.env.VUE_APP_API_WSS}websocket`; //这个必须域名连接，否则跨域,域名连接不上就服务器转两次就好了
      // const wsuri = `ws://10.31.0.109:8070/icps/websorketserver/31441432933961728/45425`;
      //const wsuri = `ws://10.31.5.70:3306/icps/websorketserver/${this.stationInfo.id}/${this.fourNumber}`;//测试地址
      const wsuri = process.env.VUE_APP_API_CL_WSS + `icps/websorketserver/${this.stationInfo.id}/${this.fourNumber}`; //正式地址
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketonclose;
    },
    //生成随机四位数
    generateRandomFourDigitNumber() {
      let num = Math.floor(Math.random() * 10000);
      // 如果生成的数小于1000，则在前面补零
      num = num < 1000 ? "0" + num : num;
      // 如果生成的数小于100，则再次补零
      num = num < 100 ? "0" + num : num;
      // 如果生成的数小于10，则再次补零
      num = num < 10 ? "0" + num : num;
      return num;
    },
    websocketonerror() {
      //连接建立失败重连
      const self = this;
      if (self.count == 0) {
        self.count++;
        clearTimeout(self.setTime);
        self.setTime = setTimeout(function () {
          self.initWebSocket();
          self.count = 0;
        }, 3000);
      }
    },
    websocketonclose() {
      //关闭
      console.log("--------连接断开了-------");
      const self = this;
      clearTimeout(self.setTime);
      self.setTime = setTimeout(function () {
        self.initWebSocket();
      }, 3000);
    },
    websocketonmessage(e) {
      //数据接收
      const data = JSON.parse(e.data);
      this.tableData3Init(data);
    },
    websocketonopen() {
      clearInterval(this.setTime);
      clearInterval(this.time);
      this.time = setInterval(function () { }, 5000);
    },
    sendData(data) {
      if (!window.WebSocket) {
        return;
      }
      if (this.websock.readyState == WebSocket.OPEN) {
        this.websock.send(data);
      } else {
        this.initWebSocket();
      }
    },
    //websock 结束
    //车辆信息 开始
    addCar() {
      this.queryWaitLineUpCars();
      this.carForm = this.$options.data().carForm;
      this.addCarDig = true;
      if (this.lineGroupList.length == 1) {
        this.carForm.queueUpLineGroup = this.lineGroupList[0].groupNum;
        this.carForm.queueUpLine = this.lineGroupList[0].name;
      }
      setTimeout(() => {
        this.$refs.carForm.clearValidate();
      }, 10);
    },
    saveCarAdd() {
      this.$refs["carForm"].validate(valid => {
        if (valid) {
          this.saveload = true;
          this.carForm.stationId = this.stationInfo.id;
          saveNewTankerUp(this.carForm)
            .then(res => {
              if (res.code == 1001) {
                this.$message.success("保存成功!");
                this.addCarDig = false;
              }
              this.saveload = false;
            })
            .catch(() => {
              this.saveload = false;
            });
        } else {
          return false;
        }
      });
    },
    //车辆信息 结束
    //生产任务 开始
    changePrint(val) {
      console.log(val);
      console.log(this.printStatus);
      if (val) {
        // this.printFun();
        this.printTime = "";
        this.printTime = setInterval(this.printFun, 20000);
        if (this.stationTaskListTime) {
          clearInterval(this.stationTaskListTime);
        }
        if (this.planListTime) {
          clearInterval(this.planListTime);
        }
      } else {
        this.stationTaskListTime = "";
        this.stationTaskListTime = setInterval(this.getStationTaskList, 20000);
        this.planListTime = "";
        this.planListTime = setInterval(this.queryPlanList, 20000);
        if (this.printTime) {
          clearInterval(this.printTime);
        }
      }
    },
    //批量打印
    printFun() {
      console.log("printFun");
      // let ids = this.tableData2.reduce((pre, cur) => {
      //   let lineItem = this.printSetData.find(item => item.name == cur.proLine);
      //   if (lineItem.ticketMachineConfigure != "1") {
      //     pre.push(cur.id);
      //   }
      //   return pre;
      // }, []);
      let ids = this.tableData2.map(item => item.id);
      console.log(ids);
      //测试数据
      // let res = {
      //   templets: [
      //     {
      //       id: "179780390561648640",
      //       content:
      //         '{"dataList":[{"type":"text","attr":{"left":41.171875,"top":33,"fontSize":"15","width":5,"fontWeightBold":false,"fontStyleItalic":false,"textDecorationUnderLine":false},"value":"ceshi","dataAttr":{"type":"fixed","dataSource":""}},{"type":"text","attr":{"left":279.171875,"top":194,"fontSize":"15","width":5,"fontWeightBold":false,"fontStyleItalic":false,"textDecorationUnderLine":false},"value":"文本控件","dataAttr":{"type":"fixed","dataSource":""}},{"type":"text","attr":{"left":43.171875,"top":111,"fontSize":"15","width":5,"fontWeightBold":false,"fontStyleItalic":false,"textDecorationUnderLine":false},"value":"文本控件","dataAttr":{"type":"custom","dataSource":"engineeringName"}},{"type":"horizontalLine","attr":{"left":236.171875,"top":299,"width":5,"height":1}},{"type":"verticalLine","attr":{"left":280.171875,"top":15,"width":1,"height":2}},{"type":"qrcode","attr":{"left":536.171875,"top":0,"width":"3"},"value":"","dataAttr":{"type":"custom","dataSource":["chongqingQR"]}},{"type":"text","attr":{"left":43.171875,"top":193,"fontSize":"15","width":5,"fontWeightBold":false,"fontStyleItalic":false,"textDecorationUnderLine":false},"value":"文本控件","dataAttr":{"type":"custom","dataSource":"codeUrl"}}],"canvasSize":{"x":"21","y":"9.3"}}',
      //     },
      //   ],
      //   logistics: [
      //     {
      //       orderNo: "JC01P2407055855_1",
      //       customerName: "广州工程总承包集团有限公司",
      //       productName: "C20",
      //       structuralParts: "测试",
      //       planNum: 12.5,
      //       pouringMethod: "拖泵外转,38m车泵",
      //       engineeringName: "美库成都青白江冷链供应链中心2",
      //       serviceContract: "八通华西建材公司",
      //       cumulativeTrains: 5,
      //       totalVolume: 17,
      //       haulDistance: null,
      //       carCompany: "金洪运",
      //       pumpingUnit: null,
      //       templateId: "179780390561648640",
      //       proTime: "2024-07-25 13:35:36",
      //       carNo: "川B12345",
      //       faceValue: 8,
      //       dutySite: "崇州站",
      //       productionLine: "1号线",
      //       remark: "联系人:10 电话:10010100101",
      //       code: "JC01SCDD2407250253",
      //     },
      //     {
      //       orderNo: "JC01P2407055855_1",
      //       customerName: "广州工程总承包集团有限公司",
      //       productName: "C20",
      //       structuralParts: "测试",
      //       planNum: 12.5,
      //       pouringMethod: "拖泵外转,38m车泵",
      //       engineeringName: "美库成都青白江冷链供应链中心",
      //       serviceContract: "八通华西建材公司",
      //       cumulativeTrains: 5,
      //       totalVolume: 17,
      //       haulDistance: null,
      //       carCompany: "金洪运",
      //       pumpingUnit: null,
      //       templateId: "",
      //       proTime: "2024-07-25 13:35:36",
      //       carNo: "川B12345",
      //       faceValue: 8,
      //       dutySite: "崇州站",
      //       productionLine: "1号线",
      //       remark: "联系人:10 电话:10010100101",
      //       code: "JC01SCDD2407250222",
      //     },
      //     {
      //       orderNo: "JC01P2407055855_2",
      //       customerName: "广州工程总承包集团有限公司",
      //       productName: "C20",
      //       structuralParts: "测试",
      //       planNum: 12.5,
      //       pouringMethod: "拖泵外转,38m车泵",
      //       engineeringName: "美库成都青白江冷链供应链中心1",
      //       serviceContract: "八通华西建材公司",
      //       cumulativeTrains: 5,
      //       totalVolume: 17,
      //       haulDistance: null,
      //       carCompany: "金洪运",
      //       pumpingUnit: null,
      //       templateId: "179780390561648640",
      //       proTime: "2024-07-25 13:35:36",
      //       carNo: "川B12345",
      //       faceValue: 8,
      //       dutySite: "崇州站",
      //       productionLine: "1号线",
      //       remark: "联系人:10 电话:10010100101",
      //       code: "JC01SCDD2407250254",
      //     },
      //   ],
      //   notHandle: null,
      // };
      // if (res.logistics) {
      //   let printBatchData = res.logistics;
      //   printBatchData.forEach((item, index) => {
      //     if (!item.templateId) {
      //       this.$message({
      //         showClose: true,
      //         duration: 6000,
      //         message: `运输号${item.code}未配置打印模板`,
      //         type: "warning",
      //       });
      //       return;
      //     }
      //     setTimeout(() => {
      //       let lineItem = this.printSetData.find(item4 => item4.name == item.productionLine);
      //       this.printerName = lineItem.printerName;
      //       this.printData = item;
      //       this.templateId = item.templateId;
      //       this.$refs["printer"].print(this.templateId,this.printData);
      //     }, 100 * (index + 1));
      //   });
      // }
      //正式代码
      saveProDispatch({ productionSiteId: this.stationInfo.id, printType: 0, ids: ids }).then(res => {
        if (res.code == 1001) {
          if (res.data.notHandle) {
            let carTxt = res.data.notHandle.reduce((pre, cur) => {
              pre = pre ? pre + "," + cur.carNo : cur.carNo;
              return pre;
            }, "");
            this.$notify({
              title: "未取样车辆",
              message: `${carTxt}未取样!`,
              position: "bottom-right",
            });
          }
          if (res.data.logistics) {
            let printBatchData = res.data.logistics;
            printBatchData.forEach((item, index) => {
              if (!item.templateId) {
                this.$message({
                  showClose: true,
                  duration: 6000,
                  message: `运输号${item.code}未配置打印模板`,
                  type: "warning",
                });
                return;
              }
              setTimeout(() => {
                let lineItem = this.printSetData.find(item4 => item4.name == item.productionLine);
                if (lineItem.ticketMachineConfigure != "1") {
                  this.printerName = lineItem.printerName;
                  this.printData = item;
                  this.templateId = item.templateId;
                  this.$nextTick(() => {
                    this.$refs['printer'].print(this.templateId, this.printData);
                  });
                }

              }, 800 * (index + 1));
            });
          }

          this.getStationTaskList();
          this.queryPlanList();
        }
      });
    },
    //单独打印
    print: _debounce(function () {
      this.buttonStatus = true;
      saveProDispatch({ productionSiteId: this.stationInfo.id, printType: 1, ids: [this.selectRow.id] })
        .then(res => {
          if (res.code == 1001) {
            if (res.data.logistics) {
              this.printerName = "";
              let lineItem = this.printSetData.find(item => item.name == this.selectRow.proLine);
              this.printerName = lineItem.printerName;
              if (lineItem.ticketMachineConfigure != "1") {
                if (!res.data.logistics[0].templateId) {
                  this.$message.warning(`运输号${res.data.logistics[0].code}未配置打印模板`);
                  return;
                }
                this.printData = res.data.logistics[0];
                this.templateId = res.data.logistics[0].templateId;
                this.$refs["printer"].print(this.templateId, this.printData);
              }
            }
            if (res.data.notHandle) {
              let carTxt = res.data.notHandle.reduce((pre, cur) => {
                pre = pre ? pre + "," + cur.carNo : cur.carNo;
                return pre;
              }, "");
              this.$notify({
                title: "未取样车辆",
                message: `${carTxt}未取样!`,
                position: "bottom-right",
              });
            }
            this.getStationTaskList();
            // this.queryPlanList();
          }
          this.buttonStatus = false;
        })
        .catch(() => {
          this.buttonStatus = false;
        });
    }, 1000),
    openPrintSet() {
      this.queryTicketMachineCon();
      this.printSetDig = true;
    },
    savePrintSet(row) {
      updateTicketConfig({ id: row.id, ticketMachineConfigure: row.ticketMachineConfigure, printerName: row.printerName })
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
          } else {
            this.queryTicketMachineCon();
          }
        })
        .catch(() => {
          this.queryTicketMachineCon();
        });
    },
    //打票机设置列表
    queryTicketMachineCon() {
      queryTicketMachineCon({ stationId: this.stationInfo.id }).then(res => {
        if (res.code == 1001) {
          this.printSetData = res.data;
        }
      });
    },
    //单选选中事件
    handleCurrentChange(row) {
      if (row) {
        this.selectRow = JSON.parse(JSON.stringify(row));
      } else {
        this.selectRow = {};
      }
    },
    //作废
    deleteTask() {
      if (!this.selectRow.id) {
        this.$message.warning("请选择一条任务再进行操作！");
        return;
      }
      this.$confirm(`请确认作废该任务？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        deleteTask({ productionSiteId: this.stationInfo.id, ids: [this.selectRow.id] }).then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
          }
          this.getStationTaskList();
        });
      });
    },
    //获取列表
    getStationTaskList() {
      let _this = this;
      let oldData = this.selectRow;
      queryStationTaskList(this.tableParams2).then(res => {
        if (res.code == 1001) {
          _this.tableData2 = res.data;
          let selectRow = res.data.find(item => item.id == oldData.id);
          if (selectRow) {
            _this.$refs.tableData2.setCurrentRow(selectRow);
          } else {
            _this.$refs.tableData2.setCurrentRow(null);
          }
          _this.$refs.tableData2.doLayout();
        }
      });
    },
    //生产任务 结束
    //自动发料 开始
    autoIssueGoods(row) {
      this.low = JSON.parse(JSON.stringify(row));
      this.autoFormData = this.$options.data().autoFormData
      this.autoFormData.engineeringName = row.engineeringName;
      this.autoFormData.pouringMethod = row.pouringMethod;
      this.autoFormData.stationName = row.stationName;
      this.autoFormData.stationId = row.stationId;
      this.autoFormData.product = row.productName;
      this.autoFormData.structuralParts = row.structuralParts;
      this.autoFormData.planId = row.planId;
      this.autoFormData.planCode = row.orderNo;
      this.autoFormData.whetherCalculateThesurplus = row.whetherCalculateTheSurplus;
      this.autoFormData.remark = row.remark;
      console.log(row)
      queryChildSum({planId:row.planId}).then(res => {
        if(res.code == 1001) {
          this.cumulativeData = res.data
        }
      })
      querySpecailProduct({ stationId: row.stationId }).then(res => {
        if (res.code == 1001) {
          this.productList = res.data
          this.autoIssueGoodsDig = true
        }
      })

    },
    adjustTask(row) {
      this.autoUpdateFormData.id = row.id
      this.autoUpdateFormData.planNum = row.planNum
      this.autoUpdateFormData.sendFrequency = row.sendFrequency
      this.autoUpdateFormData.planStartTime = row.planStartTime
      this.autoUpdateFormData.nextSendTime = row.nextSendTime
      this.autoUpdateFormData.whetherCalculateThesurplus = row.whetherCalculateThesurplus
      this.autoUpdateFormData.remark = row.remark
      queryChildSum({planId:row.planId}).then(res => {
        if(res.code == 1001) {
          this.cumulativeData = res.data
        }
      })
      this.autoGoodsUpdateDig = true
    },
    closeAutoGoods() {
      this.autoFormData = this.$options.data().autoFormData;
      this.autoIssueGoodsDig = false;
    },
    closeAutoGoodsUpdate() {
      this.autoUpdateFormData = this.$options.data().autoUpdateFormData;
      this.autoGoodsUpdateDig = false;
    },
    saveAutoIssueGoods: _debounce(function () {
      this.$refs["autoFormData"].validate(valid => {
        if (valid) {
          addAutoSendMaterial(this.autoFormData).then(res => {
            if (res.code == 1001) {
              this.$message.success('保存成功!')
              this.getStationTaskList();
              this.autoIssueGoodsDig = false;
            }
          })
        } else {
          return false;
        }
      });
    }, 1000),
    AutoIssueGoodsUpdate: _debounce(function () {
      this.$refs["autoUpdateFormData"].validate(valid => {
        if (valid) {
          adjustTask(this.autoUpdateFormData).then(res => {
            if (res.code == 1001) {
              this.$message.success('保存成功!')
              this.queryPlanList();
              this.autoGoodsUpdateDig = false;
            }
          })
        } else {
          return false;
        }
      });
    }, 1000),
    //自动发料 结束
    //订单部分 开始
    //发料部分
    selectCar(item) {
      this.formData.carNo = item.carNo;
      this.formData.driverName = item.userName;
      this.formData.driverId = item.userId;
      this.formData.driverPhone = item.phone;
      this.formData.transferAmount = item.oddmentsNum || 0;
      this.formData.faceValue = item.maxLoad || 0;
      this.formData.maxLoad = item.maxLoad;
      this.carPlan = item.planCode;
      this.inputFaceValue();
    },
    issueGoods(row) {
      //获取发料需要的数据
      this.low = JSON.parse(JSON.stringify(row));
      this.formData = this.$options.data().formData;
      let that = this;
      queryOtherData({ productionSiteId: this.stationInfo.id, planId: row.planId }).then(res => {
        if (res.code == 1001) {
          this.formData.engineeringName = row.engineeringName;
          this.formData.pouringMethod = row.pouringMethod;
          this.formData.productionSite = row.stationName;
          this.formData.productionSiteId = row.stationId;
          this.formData.productName = row.productName;
          this.formData.structuralParts = row.structuralParts;
          this.formData.distance = row.distance;
          this.formData.lossNum = row.lossNum || 0;
          this.formData.planId = row.planId;
          this.formData.remark = row.remark;
          this.formData.limitNum = res.data.limitNum;
          this.$set(this.formData, 'whetherCalculateTheSurplus', row.whetherCalculateTheSurplus)
          this.formData.proLine = "";
          this.formData.proLineId = "";
          this.formData.proLineCode = "";
          this.carList = [];
          this.peoplelist = [];
          // this.peoplelist = res.data.peoplelist;
          this.productList = res.data.productList;
          if (res.data.lineCode) {
            let line = this.lineList.find(item => item.code == res.data.lineCode);
            if (this.low.lineId && this.low.lineId.indexOf(line.id) !== -1) {
              this.formData.proLine = line.name;
              this.formData.proLineId = line.id;
              this.formData.proLineCode = line.code;
              // this.queryCarData(line)
              // this.issueGoodsDig = true;
              that.queryCarData(line, type => {
                that.issueGoodsDig = type;
                setTimeout(() => {
                  this.$refs.reffromData.clearValidate();
                }, 10);
              });
            } else {
              this.issueGoodsDig = true;
              setTimeout(() => {
                this.$refs.reffromData.clearValidate();
              }, 10);
            }
          } else {
            this.issueGoodsDig = true;
            setTimeout(() => {
              this.$refs.reffromData.clearValidate();
            }, 10);
          }
        }
      });
    },
    // async issueGoods(row) {
    //   setTimeout(() => {
    //     this.$refs.reffromData.clearValidate();
    //   }, 10);
    //   //获取发料需要的数据
    //   this.low = JSON.parse(JSON.stringify(row));
    //   this.formData = this.$options.data().formData;
    //   let res = await queryOtherData({ productionSiteId: this.stationInfo.id, planId: row.planId });
    //   if (res.code == 1001) {
    //     this.formData.engineeringName = row.engineeringName;
    //     this.formData.pouringMethod = row.pouringMethod;
    //     this.formData.productionSite = row.stationName;
    //     this.formData.productionSiteId = row.stationId;
    //     this.formData.productName = row.productName;
    //     this.formData.structuralParts = row.structuralParts;
    //     this.formData.lossNum = row.lossNum || 0;
    //     this.formData.planId = row.planId;
    //     this.formData.remark = row.remark;
    //     this.formData.proLine = "";
    //     this.formData.proLineId = "";
    //     this.formData.proLineCode = "";
    //     this.carList = [];
    //     this.peoplelist = [];
    //     // this.peoplelist = res.data.peoplelist;
    //     this.productList = res.data.productList;
    //     if (res.data.lineCode) {
    //       let line = this.lineList.find(item => item.code == res.data.lineCode);
    //       if (this.low.lineId && this.low.lineId.indexOf(line.id) !== -1) {
    //         this.formData.proLine = line.name;
    //         this.formData.proLineId = line.id;
    //         this.formData.proLineCode = line.code;
    //         // this.queryCarData(line)
    //         // this.issueGoodsDig = true;
    //         this.queryCarData(line, type => {
    //           this.issueGoodsDig = type;
    //           alert('12')
    //         });
    //       }
    //     } else {
    //       this.issueGoodsDig = true;
    //     }
    //   }
    // },
    //根据生产线获取车辆信息
    queryCarData(item, callback) {
      if (!this.low.lineId || this.low.lineId.indexOf(item.id) === -1) {
        this.$message.warning("当前生产线未维护配比!");
        this.formData.proLine = "";
        this.formData.proLineId = "";
        this.formData.proLineCode = "";
        this.carList = [];
        this.peoplelist = [];
        return;
      }
      this.formData.proLine = item.name;
      this.formData.proLineId = item.id;
      this.formData.proLineCode = item.code;
      this.formData.operatorId = "";
      this.formData.operator = "";
      this.formData.carNo = "";
      this.formData.driverName = "";
      this.formData.faceValue = "";
      this.formData.transferAmount = "";
      this.formData.proNum = "";
      queryCarData({ productionSiteId: this.stationInfo.id, proLine: this.formData.proLineCode }).then(res => {
        if (res.code == 1001) {
          this.carList = res.data.carNos;
          this.peoplelist = res.data.peoples;
          if (res.data.peoples.length == 1) {
            this.formData.operatorId = res.data.peoples[0].userId;
            this.formData.operator = res.data.peoples[0].userName;
          }
          if (this.carList.length > 0) {
            this.selectCar(this.carList[0]);
          }
          callback(true);
        }
      });
    },
    inputFaceValue() {
      if (this.formData.limitNum !== '' && this.formData.faceValue <= this.formData.limitNum) {
        this.formData.proNum = Number(this.formData.faceValue - this.formData.transferAmount).toFixed(2);
      } else {
        this.formData.proNum = Number(this.formData.faceValue - (this.formData.whetherCalculateTheSurplus == '0' ? 0 : this.formData.lossNum) - this.formData.transferAmount).toFixed(2);
      }

      if (this.formData.proNum < 0) {
        this.formData.proNum = 0;
      }
      if (this.formData.maxLoad ? this.formData.faceValue > this.formData.maxLoad : false) {
        this.$message("提示：当前输入货票量大于该车最大载重量!");
      }
    },
    sendMaterials() {
      this.saveload = true;
      if (this.formData.whetherCalculateTheSurplus == 0) {
        this.formData.lossNum = 0
      }
      if (this.formData.limitNum !== '' && this.formData.faceValue <= this.formData.limitNum) {
        this.formData.lossNum = 0
      }
      sendMaterials(this.formData)
        .then(res => {
          if (res.code == 1001) {
            if (res.data) {
              this.$notify({
                title: "提示:",
                message: `${this.formData.carNo}需要检测!`,
                position: "bottom-right",
              });
            } else {
              this.$message.success("保存成功!");
            }
            this.getStationTaskList();
            this.issueGoodsDig = false;
          }
          this.saveload = false;
        })
        .catch(() => {
          this.saveload = false;
        });
    },
    closeGoods() {
      this.formData = this.$options.data().formData;
      console.log(this.formData);
      this.issueGoodsDig = false;
    },
    saveIssueGoods: _debounce(function () {
      this.$refs["reffromData"].validate(valid => {
        if (valid) {
          if (this.carPlan && this.carPlan != this.low.orderNo && this.formData.transferAmount) {
            this.$message.warning(`${this.formData.carNo}车辆有余料其${this.carPlan}任务与该任务不一致 无法派单！`);
            return;
          }
          if (this.formData.proNum > this.formData.faceValue) {
            this.$message.warning(`生产方量大于货票量，无法派单！`);
            return;
          }
          let product = this.productList.find(item => item.productName == this.formData.productName);
          console.log(product);
          let text = "";
          if (this.formData.proNum == 0) {
            text = "该车生产方量为0，请确认是否为补单，不进行生产";
          }
          if (this.low.cumulativeUseNum * 1 + this.formData.proNum * 1 > this.low.planNum) {
            text = text ? text + "-" + "该计划实际已发料方量大于计划发料量" : "该计划实际已发料方量大于计划发料量";
          }
          if (product?.whetherSend == 0) {
            this.formData.whetherSend = 0;
            text = text ? text + "-" + "该产品不传输工控系统" : "该产品不传输工控系统";
          }
          if (text) {
            this.$confirm(`${text}；请确认是否继续发料？`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "关闭",
              cancelButtonClass: "bottom_all_two",
              confirmButtonClass: "bottom_all",
              type: "warning",
            }).then(() => {
              this.sendMaterials();
            });
          } else {
            this.sendMaterials();
          }
        } else {
          return false;
        }
      });
    }, 1000),
    getsum(key) {
      let sum = this.tableData1.reduce((prev, curr) => {
        return prev + curr[key];
      }, 0);
      return Number(sum).toFixed(2)
    },
    queryPlanList() {
      queryEngeningCars({code: this.stationInfo.id}).then(res => {
        if (res.code == 1001) {
          this.engCar = res.data
        }
      })
      if (this.currenindex == 1) {
        if (!this.tableParams1.pourTime) {
          this.$message.warning("请选择浇筑时间!");
          return;
        }
        this.table1Load = true;
        queryPlanList(this.tableParams1)
          .then(res => {
            if (res.code == 1001) {
              this.$set(this, 'tableData1', [])
              res.data?.forEach(item => {
                if (item.materialIssueType == 1) {
                  this.isMaterialIssue = true
                }
              })
              this.$set(this, 'tableData1', res.data)
              if (this.showAll != 'table_1') {
                let obj = {
                  productName: "合计",
                  cumulativeCar: this.getsum('cumulativeCar'),
                  planNum: this.getsum('planNum'),
                  cumulativeUseNum: this.getsum('cumulativeUseNum'),
                  outCarNoCount: this.getsum('outCarNoCount'),
                }
                this.tableData1.push(obj)
              }
              console.log(this.tableData1)
            }
            this.table1Load = false;
          })
          .catch(() => {
            this.table1Load = false;
          });
      } else {
        queryTaskList(this.tableParams4)
          .then(res => {
            if (res.code == 1001) {
              this.tableData1 = []
              this.tableData1 = res.data;
              if (this.showAll != 'table_1') {
                let obj = {
                  product: "合计",
                  planNum: this.getsum('planNum'),
                  cumulativeCar: this.getsum('cumulativeCar'),
                  cumulativeUseNum: this.getsum('cumulativeUseNum'),
                }
                this.tableData1.push(obj)
              }
            }
            this.table1Load = false;
          })
          .catch(() => {
            this.table1Load = false;
          });
      }

    },
    //取消
    cancelPlan(row) {
      this.$confirm(`请确认取消该计划？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        cancelPlan({ id: row.planId }).then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
          }
          this.queryPlanList();
        });
      });
    },
    //开工完工
    workStartEnd(status, row) {
      if (status == 4) {
        this.$confirm(`完工计划将不能进行生产，请确认是否要完成${row.orderNo}计划？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        }).then(() => {
          updatePlan({ id: row.planId, planStatus: 4 }).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功!");
            }
            this.queryPlanList();
          });
        });
      }
      if (status == 3) {
        this.$confirm(`开工计划将进入生产，请确认${row.orderNo}计划是否要开工？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        }).then(() => {
          updatePlan({ id: row.planId, planStatus: 3 }).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功!");
            }
            this.queryPlanList();
          });
        });
      }
      if (status == 2) {
        this.$confirm(`请确认${row.orderNo}计划是否要补单重新开工？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        }).then(() => {
          updatePlan({ id: row.planId, planStatus: 2 }).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功!");
            }
            this.queryPlanList();
          });
        });
      }
    },
    //自动发料修改状态
    updateTask(row, taskStatus) {
      if (taskStatus == 3 || taskStatus == 1) {
        let txt = taskStatus == 3 ? `请确认是否完成？` : `${row.engineeringName}:${row.product},是否继续?`
        this.$confirm(txt, "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        }).then(() => {
          this.table1Load = true;
          updateTask({ id: row.id, taskStatus: taskStatus })
            .then(res => {
              if (res.code == 1001) {
                this.$message.success("修改成功!");
              }
              this.queryPlanList();
            })
            .catch(() => {
              this.table1Load = false;
            });
        });
      } else {
        this.table1Load = true;
        updateTask({ id: row.id, taskStatus: taskStatus })
          .then(res => {
            if (res.code == 1001) {
              this.$message.success("修改成功!");
            }
            this.queryPlanList();
          })
          .catch(() => {
            this.table1Load = false;
          });
      }
    },
    //全部暂停
    pauseAllTask() {
      this.$confirm(`请确认是否全部暂停？`, "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        this.table1Load = true;
        pauseAllTask({ stationId: this.stationInfo.id })
          .then(res => {
            if (res.code == 1001) {
              this.$message.success("修改成功!");
            }
            this.queryPlanList();
          })
          .catch(() => {
            this.table1Load = false;
          });
      });
    },
    //取消限制
    cancelLimit(row, newSmallSquareMark) {
      this.table1Load = true;
      cancelLimit({ id: row.id, smallSquareMark: newSmallSquareMark })
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("操作成功!");
          }
          this.queryPlanList();
        })
        .catch(() => {
          this.table1Load = false;
        });
    },
    //优先等级修改
    changeTransportSort(item, row) {
      this.table1Load = true;
      if (this.currenindex == 1) {
        updatePlan({ id: row.planId, transportSort: item.itemValue })
          .then(res => {
            if (res.code == 1001) {
              this.$message.success("修改成功!");
            }
            this.queryPlanList();
          })
          .catch(() => {
            this.table1Load = false;
          });
      } else {
        updateTask({ id: row.id, sortNum: item.itemValue })
          .then(res => {
            if (res.code == 1001) {
              this.$message.success("修改成功!");
            }
            this.queryPlanList();
          })
          .catch(() => {
            this.table1Load = false;
          });
      }

    },
    //订单部分 结束
    //人员配置开始
    savePerson() {
      let personNull = false;
      this.personData.forEach(item => {
        if (!item.userId) {
          personNull = true;
        }
      });
      if (personNull) {
        this.$message.warning("人员不能为空!");
        return;
      }
      savePeople({ stationId: this.stationInfo.id, manList: this.personData }).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.personDig = false;
        }
      });
    },
    lineSetOpen() {
      this.lineSetDig = true
      this.getLineData()
    },
    personOpen() {
      queryPeople({ stationId: this.stationInfo.id }).then(res => {
        if (res.code == 1001) {
          if (res.data.length > 0) {
            console.log(1);
            // let arr = [];
            // res.data.forEach(item => {
            //   if (item.userType == 1) {
            //     let findIndex = arr.findIndex(item2 => item.lineId == item2.lineId);
            //     if (findIndex !== -1) {
            //       arr[findIndex].userId.push(item.userId);
            //     } else {
            //       arr.unshift({
            //         userType: 1,
            //         userId: [item.userId],
            //         userName: "",
            //         lineId: item.lineId,
            //         lineName: item.lineName,
            //         stationId: item.stationId,
            //         id: item.id,
            //       });
            //     }
            //   } else {
            //     let findIndex2 = arr.findIndex(item2 => item2.userType == 2);
            //     if (findIndex2 !== -1) {
            //       arr[findIndex2].userId.push(item.userId);
            //     } else {
            //       arr.push({
            //         userType: 2,
            //         userId: [item.userId],
            //         userName: "",
            //         lineId: "",
            //         lineName: "",
            //         stationId: item.stationId,
            //         id: item.id,
            //       });
            //     }
            //   }
            // });

            this.personData = res.data;
            this.lineList.forEach(item => {
              let lineIndex = this.personData.findIndex(item2 => item2.lineId == item.id);
              if (lineIndex == -1) {
                this.personData.splice(-1, 0, { userType: 1, userId: [], userName: "", lineId: item.id, lineName: item.name, stationId: "", id: "" });
              }
            });
          } else {
            console.log(2);
            let arr = [];
            this.lineList.forEach(item => {
              let obj = { userType: 1, userId: [], userName: "", lineId: item.id, lineName: item.name, stationId: "", id: "" };
              arr.push(obj);
            });
            arr.push({ userType: 2, userId: [], userName: "", lineId: "", lineName: "", stationId: "", id: "" });
            this.personData = arr;
          }
        }
      });
      this.personDig = true;
    },
    //人员配置结束
    arraySpanMethod({ column, rowIndex, columnIndex }) {
      if (rowIndex === 2) {
        if (columnIndex == 0) {
          return [1, 1];
        } else {
          let obj = this.table3.find(item => item.label == column.label);
          let obj2 = this.table3.find(item => item.label == this.table3[columnIndex - 1].label);
          if (obj.groupNum == obj2.groupNum) {
            return [0, 0];
          } else {
            return [1, obj.lineNum];
          }
        }
      }
    },
    //车辆信息表格数据初始化
    tableData3Init(data) {
      let tableData = JSON.parse(JSON.stringify(data));
      let table = [{ label: " 生产线", prop: "lineName", status: true, width: "110", groupNum: 0 }];
      let newTableData = []; //目标数据数组
      let obj = {
        lineName: "装料",
      };
      let obj1 = {
        lineName: "准备",
      };
      let obj2 = {
        lineName: "排队",
      };
      tableData.forEach(item => {
        item.lineData.forEach(item2 => {
          let isLine = false; //判断生产线是否存入表格中  开始
          table.forEach(item3 => {
            if (item3.prop == item2.lineName) {
              isLine = true;
            }
          });
          if (!isLine) {
            table.push({ label: item2.lineName, prop: item2.lineName, status: true, width: "auto", groupNum: item.groupNum, lineNum: item.lineNum });
          } //判断生产线是否存入表格中   结束
          //数据存入对应的行中
          obj[item2.lineName] = item2.loading;
          obj1[item2.lineName] = item2.prepare;
          const objArr = item.lineUp.map(item => ({ carNo: item }));

          objArr.forEach(carItem => {
            let carEng = this.engCar.filter(carEngIem => carItem.carNo.includes(carEngIem.carNo))
              .map(carEngIem => carEngIem.NAME);
            carItem['carEng'] = carEng
          })
          obj2[item2.lineName] = objArr;
        });
      });
      newTableData.push(obj);
      newTableData.push(obj1);
      newTableData.push(obj2);
      this.tableData3New = newTableData;
      console.log(this.tableData3New)
      this.table3 = table;
    },
    //移动
    addSequence(isTask, item, group) {
      this.$confirm(`请确认是否${isTask == 1 ? '前移' : '置顶'}${item}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        let carNo = ""
        if (item.indexOf('(') !== -1) {
          carNo = item.split('(')[0];
        } else {
          carNo = item.split('/')[0];
        }
        console.log(carNo); // 输出: 川A0001
        movePosition({
          carNo: carNo,
          stationId: this.stationInfo.id,
          isTask: isTask, //1 前移 2 置顶 3 后退
          queueUpLineGroup: group, //排队生产线分组
        }).then(res => {
          if (res.code == 1001) {
            this.$message.success("移动成功!");
          }
        });
      });
    },
    //删除
    deleteCar(item) {
      this.$confirm(`请确认是否删除${item}排队？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        let carNo = ""
        if (item.indexOf('(') !== -1) {
          carNo = item.split('(')[0];
        } else {
          carNo = item.split('/')[0];
        }
        deleteTanekrUp({
          carNo: carNo,
          stationId: this.stationInfo.id,
        }).then(res => {
          if (res.code == 1001) {
            this.$message.success("删除成功!");
          }
        });
      });
    },
    choose(num) {
      this.currenindex = num;
      if (num == 2) {
        this.table1 = this.table1_4;
        this.showAll = 'table1_4'
      } else {
        this.table1 = this.table1_2;
        this.showAll = 'table1_2'
      }
      this.queryPlanList();
      this.$refs.table1.doLayout();
      this.$forceUpdate();
    },
    //切换订单状态
    changeOrderStatus(item) {
      if (item.value == "2") {
        this.table1 = this.table1_1;
        this.showAll = 'table1_1'
      } else if (item.value == "3") {
        this.table1 = this.table1_2;
        this.showAll = 'table1_2'
      } else {
        this.table1 = this.table1_3;
        this.showAll = 'table1_3'
      }
      this.columKey = Math.random()
      this.queryPlanList();
      this.$refs.table1.doLayout();
      this.$forceUpdate();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.carNo = "";
      this.tableParam.productionSite = "";
      (this.startTimDateEndTimDate = [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")]), this.initData();
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  background: #fff;
  font-size: calc(#{$font_size} + 2px);
}

.card_nav {
  height: 46px;
}

.card_bottom {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;

  .card_bottom_left {
    display: flex;
    align-items: center;
    font-size: $font_size;
  }
}

.card_info {
  padding: 0 2px;
}

.search {
  padding: 5px 20px 0px 20px;
  height: 50px;
  position: relative;
}

.searchLeft {
  position: absolute;
  top: 5;
  left: 25px;
}

.searchRight {
  position: absolute;
  top: 5;
  right: 10px;
  display: flex;
  align-items: center;
}

.car {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.carItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: $bg_color !important;
}

.outCarNos {
  width: 280px;
}

.outCarNos span {
  display: inline-block;
  text-align: justify;
  white-space: nowrap;
  /* 允许自动换行 */
}

.el-dropdown [disabled] {
  color: #606266;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sumRow {
  background-color: $bg_color;
  color: #fff
}

.carSearch {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.tabNav {
  display: flex;
  align-items: center;
  /* 垂直居中 */
  margin: 20px;
  /* 统一的外边距 */
  width: calc(100% - 40px);
  /* 使宽度占满屏幕，减去左右边距 */
}

.tabtopLeft {
  display: flex;
  align-items: center;
  /* 垂直居中 */
  border: $bg_color 1px solid;
  border-radius: 4px;
}

.tabtopLeft>div {
  height: 40px;
  width: 190px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;

  .text {
    width: 188px;
    @include discen;
    line-height: 40px;
    color: $bg_color;
  }

  .active {
    width: 188px;
    @include discen;
    line-height: 40px;
    color: #ffffff;
    background: $bg_color;
    border-radius: 4px;
  }

  .hr {
    height: 20px;
    width: 2px;
    background: $bg_color;
  }
}
</style>
